export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-clipboard-848c22c3f56bcc0ae1a945a520719e17.svg";